import React from 'react';

import confirmationStyles from '../ConfirmationPopUp/ConfirmationPopUp.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';

export default function AccessDeniedModal({
  open,
  onClose,
  allowedPrefixes,
  lastAllowedPath,
  fallbackAllowedPath,
  shouldRedirectOnDenied,
  navigate,
  getFullPath,
}) {
  if (!open) return null;

  return (
    <div className={confirmationStyles.modalOverlay} onClick={onClose}>
      <div className={confirmationStyles.modalContent} onClick={(e) => e.stopPropagation()}>
        <p className={confirmationStyles.text} style={{ marginBottom: '8px' }}>
          Access to Moment is currently disabled
        </p>
        <p className={confirmationStyles.text} style={{ color: '#555', marginTop: '0px' }}>
          Please contact an administrator to update your access to Moment. If you believe this is a mistake, try signing
          out and back in, or reach out to IT support.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
          <div style={{ width: '90px', height: '28px' }}>
            <button
              onClick={() => {
                onClose();
                // Don't redirect users without access, just close the modal
                if (shouldRedirectOnDenied) {
                  const preferred = sessionStorage.getItem('lastAllowedPath') || lastAllowedPath || '';
                  const computeAllowed = (target) => {
                    try {
                      const u = new URL(target, window.location.origin);
                      const lower = (u.pathname || '').toLowerCase();
                      return allowedPrefixes.some((prefix) => {
                        const pl = (prefix || '').toLowerCase();
                        return lower === pl || lower.startsWith(pl + '/');
                      });
                    } catch {
                      return false;
                    }
                  };
                  const finalDest = preferred && computeAllowed(preferred) ? preferred : fallbackAllowedPath;
                  if (finalDest === fallbackAllowedPath) {
                    sessionStorage.setItem('lastAllowedPath', finalDest);
                  }
                  if (getFullPath() !== finalDest) {
                    navigate(finalDest, { replace: true });
                  }
                }
              }}
              className={buttonStyles.YesButtonComponentStyling}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


